import { IconWrapper } from '../runtime';
export default IconWrapper('h2', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.6555 9.42882C13.2471 9.10144 12.7519 9.10144 12.3436 9.42882C12.1166 9.61081 12.0578 9.85583 12.0483 10.1194C12.0374 10.423 11.7825 10.6603 11.479 10.6494C11.1754 10.6385 10.9381 10.3836 10.949 10.08C10.9631 9.68751 11.0609 9.04735 11.6555 8.57061C12.4659 7.92084 13.5332 7.92084 14.3436 8.57061C15.1245 9.19674 15.2843 10.1166 14.9662 10.9883C14.9179 11.1207 14.836 11.2506 14.7613 11.3577C14.6806 11.4731 14.5813 11.5993 14.4719 11.7299C14.2528 11.9916 13.974 12.2941 13.6781 12.6021C13.2536 13.0438 12.7823 13.5086 12.3777 13.8997H14.4995C14.8033 13.8997 15.0495 14.146 15.0495 14.4497C15.0495 14.7535 14.8033 14.9997 14.4995 14.9997H11.7647C10.9953 14.9997 10.6189 14.0583 11.1764 13.5279C11.6384 13.0882 12.3089 12.4393 12.8849 11.8399C13.1735 11.5396 13.4327 11.2576 13.6285 11.0238C13.7265 10.9067 13.8039 10.8073 13.8595 10.7277C14.1466 10.3168 14.0405 9.73751 13.6555 9.42882Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M1.75 1.75363V14.2497M9.25 1.75363V14.2497M1.75 8.00168H9.25",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});